import React from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import StarIcon from "@material-ui/icons/Star";
import PollIcon from "@material-ui/icons/Poll";
import { Link } from "react-router-dom";
import { gql, useQuery } from "@apollo/client";

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(2)
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6)
  },
  heroButtons: {
    marginTop: theme.spacing(4)
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8)
  },
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column"
  },
  cardMedia: {
    paddingTop: "56.25%" // 16:9
  },
  cardContent: {
    flexGrow: 1
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6)
  }
}));

const GET_FRONT_PAGE = gql`
  query frontPageQuery {
    FrontPage {
      total_players
      total_tournaments
      latest_tournament {
        formatted
      }
    }
  }
`;

export default function Home() {
  const classes = useStyles();
  const baseYear =
    new Date().getMonth() + 1 < 10
      ? new Date().getFullYear() - 1
      : new Date().getFullYear();
  const seasonString = `${baseYear}-${baseYear + 1}`;
  const { loading, data, error } = useQuery(GET_FRONT_PAGE, {});

  return (
    <div className={classes.heroContent}>
      <Container maxWidth="md">
        <Typography
          component="h1"
          variant="h2"
          align="center"
          color="textPrimary"
          gutterBottom
        >
          Quizbowl Stats
        </Typography>
        {data && !loading && !error && (
          <Typography
            variant="h5"
            align="center"
            color="textSecondary"
            paragraph
          >
            {data.FrontPage[0].total_players.toLocaleString()} players at{" "}
            {data.FrontPage[0].total_tournaments.toLocaleString()} tournaments
            through{" "}
            {new Date(
              data.FrontPage[0].latest_tournament.formatted
            ).toLocaleDateString()}
          </Typography>
        )}
        <Typography variant="p" align="center" color="textSecondary" paragraph>
          Stats from{" "}
          <a href="https://hsquizbowl.org/db/">the Quizbowl Resource Center</a>,{" "}
          <a href="https://stats.neg5.org/">Neg 5</a>, and{" "}
          <a href="https://www.qbwiki.com/">QB Wiki</a>
        </Typography>
        <div className={classes.heroButtons}>
          <Grid container spacing={2} justify="center">
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                startIcon={<PollIcon />}
                component={Link}
                to={`/year/${baseYear}`}
              >
                View Stats Leaders For {seasonString}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                startIcon={<StarIcon />}
                component={Link}
                to="/record"
              >
                View All-Time Records
              </Button>
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
}
